export const CLIENT_COLORS = {
  "Médico":        { bg: "var(--info-soft)",       tx: "var(--info-ink)",       dot: "var(--info)" },
  "E-commerce":    { bg: "var(--warn-soft)",        tx: "var(--warn-ink)",       dot: "var(--warn)" },
  "Mentor":        { bg: "var(--success-soft)",     tx: "var(--success-ink)",    dot: "var(--success)" },
  "Negócio Local": { bg: "var(--cat-orange-soft)",  tx: "var(--cat-orange-ink)", dot: "var(--cat-orange)" },
  "Empresa (B2B)": { bg: "var(--cat-teal-soft)",    tx: "var(--cat-teal-ink)",   dot: "var(--cat-teal)" },
  "Interno":       { bg: "var(--cat-violet-soft)",  tx: "var(--cat-violet-ink)", dot: "var(--cat-violet)" },
};

export const CYCLE = [
  { id: "1-onboarding",  s: "1", l: "Onboarding"  },
  { id: "2-auditoria",   s: "2", l: "Auditoria"   },
  { id: "3-diagnostico", s: "3", l: "Diagnóstico"  },
  { id: "4-plano",       s: "4", l: "Plano"        },
  { id: "5-execucao",    s: "5", l: "Execução"     },
  { id: "6-ac",          s: "6", l: "AC"           },
  { id: "7-at",          s: "7", l: "AT"           },
  { id: "8-novo-plano",  s: "8", l: "Novo Plano"   },
];

export const CREATIVE_PIPELINE = [
  "Ideia","Roteirizado","Gravando","Editando","Pronto","Em teste","Vencedor","Escalado","Pausado",
];

export const CR_COLORS = {
  "Ideia":       "var(--faint)",
  "Roteirizado": "var(--cat-teal)",
  "Gravando":    "var(--info)",
  "Editando":    "var(--warn)",
  "Pronto":      "var(--cat-violet)",
  "Em teste":    "var(--cat-orange)",
  "Vencedor":    "var(--success)",
  "Escalado":    "var(--primary)",
  "Pausado":     "var(--danger)",
};

export const PRI_DOT = { Alta: "var(--danger)", Média: "var(--warn)", Baixa: "var(--faint)" };

export const TASK_STATUS_COLORS = {
  "A fazer":             { bg: "var(--surface-3)",   tx: "var(--muted)" },
  "Em andamento":        { bg: "var(--info-soft)",    tx: "var(--info-ink)" },
  "Aguardando terceiro": { bg: "var(--warn-soft)",    tx: "var(--warn-ink)" },
  "Concluído":           { bg: "var(--success-soft)", tx: "var(--success-ink)" },
};

export const TASK_TYPES = ["AC","AT","Onboarding","Auditoria","Diagnóstico","Plano","Execução","Operacional","Outro"];
export const PRIORITIES = ["Alta","Média","Baixa"];
export const TASK_STATUSES = ["A fazer","Em andamento","Aguardando terceiro","Concluído"];

export const CL_CONTEUDO = [
  "Planejar pauta da semana",
  "Roteirizar Reels prioritários",
  "Criar capas no Canva",
  "Gravar Reels planejados",
  "Editar Reels gravados",
  "Criar Carrosséis da semana",
  "Criar Posts de Feed",
  "Preparar sequência de Stories",
  "Agendar publicações",
  "Monitorar engajamento dos posts",
  "Responder comentários e DMs",
];

export const CL_AGENCIA = [
  "Revisar performance dos clientes ativos",
  "Preparar relatórios mensais dos clientes",
  "Checar renovações e contratos vigentes",
  "Atualizar pipeline de prospecção",
  "Revisar faturamento do mês",
];

// ── Rotina do Gestor de Tráfego ──────────────────────────────────────────────
// Cada item tem: text (o item), oque (o que fazer na prática) e porque (por que importa).
// oque/porque aparecem no popup ao passar o mouse sobre o item no checklist.

export const CL_META = [
  { text: "Conferir entrega e gasto das campanhas",
    oque: "Verificar se todas as campanhas ativas estão entregando e gastando o planejado — sem rejeição, sem aprendizado limitado, sem verba parada.",
    porque: "Campanha parada ou estourando verba é dinheiro perdido em silêncio. Detectar em 24–48h, não no fim do mês." },
  { text: "Comparar CPL/CPA com a meta do cliente",
    oque: "Puxar o custo por lead/aquisição da semana e comparar com a meta acordada com o cliente.",
    porque: "É o número que define se a conta está saudável. Sem essa comparação, otimização vira achismo." },
  { text: "Checar frequência do público quente (>3 = alerta)",
    oque: "Ver a frequência dos conjuntos de remarketing/público quente nos últimos 7 dias.",
    porque: "Acima de ~3 o público satura: CTR cai e CPM sobe. É o sinal para trocar criativo ou expandir público." },
  { text: "Comparar criativo campeão vs. desafiante",
    oque: "Comparar CTR, hook rate e custo por resultado do criativo vencedor contra o teste da semana.",
    porque: "Criativo é 80% da performance no Meta. Conta sem teste rodando é conta envelhecendo." },
  { text: "Pausar o pior anúncio e documentar o motivo",
    oque: "Cortar o anúncio de pior desempenho da semana e anotar o porquê nas Otimizações.",
    porque: "Libera verba para o que funciona e cria o histórico de aprendizado da conta." },
  { text: "Ajustar orçamento com justificativa",
    oque: "Realocar verba entre conjuntos/campanhas com base em resultado — e registrar o motivo.",
    porque: "Escalar sem critério reseta o aprendizado do algoritmo. Toda mudança de verba precisa de um porquê." },
  { text: "Registrar a decisão da semana (escalar/pausar/testar)",
    oque: "Registrar na aba Otimizações a decisão mais importante da semana, com hipótese e resultado esperado.",
    porque: "É o que alimenta o relatório mensal e prova o valor da gestão para o cliente." },
];

export const CL_META_MENSAL = [
  { text: "Auditar públicos, exclusões e sobreposição",
    oque: "Revisar se os públicos frio/morno/quente estão bem definidos, com exclusões corretas entre etapas do funil.",
    porque: "Sobreposição faz você leiloar contra si mesmo e polui a leitura de resultado por etapa." },
  { text: "Revisar distribuição de verba no funil (TOF/MOF/BOF)",
    oque: "Conferir quanto da verba está em topo, meio e fundo — e se a proporção sustenta o volume do fundo.",
    porque: "BOF sem TOF seca em semanas. Foi exatamente o que derrubou o ROAS da Royal Charlotte." },
  { text: "Avaliar qualidade dos leads com o cliente",
    oque: "Perguntar ao cliente (ou à secretária) quantos leads viraram consulta/venda no mês.",
    porque: "CPL baixo com lead ruim é prejuízo disfarçado de resultado. O funil só fecha com o dado do cliente." },
  { text: "Planejar os testes do próximo mês",
    oque: "Definir 2–3 hipóteses de teste (criativo, público, oferta) com critério de sucesso antes do mês começar.",
    porque: "Teste planejado tem começo, meio e conclusão. Teste improvisado vira gasto sem aprendizado." },
];

export const CL_GA = [
  { text: "Revisar termos de pesquisa e negativar",
    oque: "Ler os termos que acionaram anúncios na semana e negativar os irrelevantes.",
    porque: "É o vazamento nº 1 de verba no Google. 15 minutos por semana pagam a rotina inteira." },
  { text: "Comparar CPA/ROAS com a meta do cliente",
    oque: "Puxar o CPA (ou ROAS) da semana e comparar com a meta acordada.",
    porque: "Sem meta como régua, qualquer número parece aceitável. É o indicador de saúde da conta." },
  { text: "Conferir parcela de impressões perdida",
    oque: "Ver a % de impressões perdida por orçamento e por classificação nas campanhas principais.",
    porque: "Diz se o gargalo é verba ou qualidade — e cada um pede uma decisão oposta." },
  { text: "Avaliar índice de qualidade das palavras principais",
    oque: "Conferir QS das palavras que mais gastam: CTR esperado, relevância do anúncio e experiência da LP.",
    porque: "QS baixo encarece todo clique. Melhorar anúncio/LP reduz CPC sem mexer no lance." },
  { text: "Revisar RSAs: títulos e descrições",
    oque: "Ver força do anúncio e desempenho dos ativos; trocar títulos/descrições fracos.",
    porque: "RSA com ativos ruins limita o leilão inteiro. O Google premia variedade com relevância." },
  { text: "Ajustar lances e orçamento com justificativa",
    oque: "Realocar verba/lances com base no desempenho — e registrar o motivo.",
    porque: "Mudança sem registro impede saber o que causou a melhora (ou a piora) depois." },
  { text: "Registrar a decisão da semana (escalar/pausar/testar)",
    oque: "Registrar na aba Otimizações a decisão mais importante da semana.",
    porque: "Alimenta o relatório mensal e prova o valor da gestão para o cliente." },
];

export const CL_GA_MENSAL = [
  { text: "Revisar segmentação geográfica e horários",
    oque: "Analisar desempenho por região e horário; ajustar lances ou excluir áreas ruins.",
    porque: "Verba concentrada onde converte. Região errada queima orçamento sem retorno." },
  { text: "Avaliar dispositivos e públicos de remarketing",
    oque: "Comparar CPA por dispositivo e revisar listas de remarketing ativas.",
    porque: "Mobile x desktop convertem diferente; remarketing esquecido envelhece e satura." },
  { text: "Verificar anúncios reprovados e extensões",
    oque: "Conferir reprovações, sitelinks, frases de destaque e snippets.",
    porque: "Anúncio reprovado = campanha capenga sem aviso. Extensões elevam CTR de graça." },
  { text: "Analisar leilão e concorrência",
    oque: "Ver insights de leilão: quem entrou, parcela de impressão dos concorrentes.",
    porque: "Concorrente novo agressivo explica CPC subindo — e pede resposta estratégica, não pânico." },
];

export const CL_LINKEDIN = [
  { text: "Conferir entrega e gasto vs. verba diária",
    oque: "Ver se as campanhas ativas estão entregando e comparar o gasto dos últimos 7 dias com a verba combinada.",
    porque: "O piso de lance do LinkedIn é alto e a audiência é pequena: campanha sem entrega fica parada em silêncio e a verba não recupera o mês." },
  { text: "Comparar CPL com a meta do cliente",
    oque: "Puxar o custo por lead da semana e comparar com a meta acordada — em B2B o CPL aceitável é múltiplo do de Meta/Google.",
    porque: "Sem a régua do cliente, um CPL de R$ 120 parece caro e pode ser barato para o ticket dele. É o número que define se a conta está saudável." },
  { text: "Revisar cargos, empresas e setores que consumiram verba",
    oque: "Abrir o demográfico da campanha e ver quais cargos, tamanhos de empresa e setores receberam impressão e clique.",
    porque: "É o equivalente aos termos de pesquisa do Google: o vazamento nº 1 aqui é entregar para cargo errado dentro de um público que parecia certo." },
  { text: "Checar frequência e tamanho da audiência",
    oque: "Ver a frequência dos últimos 7 dias e o tamanho estimado de cada público segmentado.",
    porque: "Público de LinkedIn satura em semanas, não em meses. Audiência abaixo de ~50 mil com frequência subindo é troca de criativo ou expansão, não aumento de lance." },
  { text: "Avaliar CTR e taxa de envio do formulário nativo",
    oque: "Comparar o CTR do anúncio com a taxa de envio do Lead Gen Form — quantos abriram e quantos concluíram.",
    porque: "Separa problema de anúncio de problema de formulário. Campo a mais no form derruba a conclusão sem mexer no CTR." },
  { text: "Conferir com o cliente a qualidade dos leads da semana",
    oque: "Perguntar quantos dos leads entregues eram do perfil combinado e quantos viraram conversa real.",
    porque: "O formulário nativo preenche sozinho: gera lead barato e frio. Sem esse retorno, otimiza-se para volume enquanto o comercial reclama de qualidade." },
  { text: "Registrar a decisão da semana (escalar/pausar/testar)",
    oque: "Registrar na aba Otimizações a decisão mais importante da semana.",
    porque: "Alimenta o relatório mensal e prova o valor da gestão para o cliente." },
];

export const CL_LINKEDIN_MENSAL = [
  { text: "Revisar a composição da audiência e o alcance restante",
    oque: "Rever os filtros de cargo, senioridade, setor e tamanho de empresa; conferir o alcance estimado contra quantos já foram impactados.",
    porque: "Em audiência pequena, o mês inteiro pode rodar sobre as mesmas pessoas. Expandir ou trocar o recorte é decisão mensal, não semanal." },
  { text: "Renovar criativos e testar um ângulo novo",
    oque: "Substituir os criativos com maior frequência acumulada e subir ao menos um ângulo diferente do vencedor.",
    porque: "Fadiga no LinkedIn aparece como CTR caindo e CPC subindo ao mesmo tempo — e sem criativo novo em fila a queda só é notada quando o CPL já dobrou." },
  { text: "Revisar lances, tipo de leilão e orçamento por campanha",
    oque: "Comparar custo por resultado entre lance manual, máximo de entrega e custo-alvo nas campanhas principais.",
    porque: "O leilão do LinkedIn pune lance mal calibrado com perda de entrega, não com gasto excessivo. É onde mais se ganha eficiência sem mexer em criativo." },
  { text: "Conferir Insight Tag e registro das conversões",
    oque: "Validar que a Insight Tag está ativa no site e que as conversões configuradas estão registrando.",
    porque: "Tag parada não dá erro: a campanha continua rodando e o relatório mostra zero conversão como se fosse desempenho ruim." },
];

// Mantidos por compatibilidade (não usados nos novos checklists)
export const CL_GM = CL_GA_MENSAL;
export const CL_GB = [];

// ── Onboarding — dois cenários com riscos opostos ────────────────────────────
// "zero": cliente que nunca anunciou → risco é EXPECTATIVA.
// "migracao": cliente insatisfeito com gestão anterior → risco é COMPARAÇÃO/ANSIEDADE.

export const CL_ONB_ZERO = [
  { text: "Alinhar expectativa: 2–4 semanas de aprendizado",
    oque: "Explicar ao cliente, ANTES de ligar campanhas, que o algoritmo precisa de 2–4 semanas e que os resultados iniciais oscilam.",
    porque: "Expectativa combinada antes vira paciência; explicada depois vira desculpa. É a maior causa de cancelamento precoce." },
  { text: "Estruturar BM, conta de anúncios e pagamento",
    oque: "Criar/organizar Business Manager, conta de anúncios em nome do cliente, cartão e limites de gasto.",
    porque: "Conta mal estruturada gera bloqueio e perde histórico — e o retrabalho depois custa semanas." },
  { text: "Instalar pixel/API de conversões e verificar domínio",
    oque: "Configurar o rastreamento com os eventos-chave testados antes da primeira campanha ir ao ar.",
    porque: "Sem rastreamento confiável, nenhuma otimização futura tem base. É o alicerce de tudo." },
  { text: "Definir meta, verba mínima e o que conta como 'resultado'",
    oque: "Acordar por escrito: CPL/CPA alvo, verba mensal mínima viável e qual evento é o resultado (lead? consulta? venda?).",
    porque: "Cliente que nunca anunciou não sabe o que esperar. Ou você define a régua, ou a frustração define por ele." },
  { text: "Garantir 3+ criativos aprovados antes de ativar",
    oque: "Produzir e aprovar no mínimo 3 criativos distintos (ângulos diferentes) antes de ligar qualquer campanha.",
    porque: "Campanha com 1 criativo não testa nada — só gasta. Sem material, a conta nasce capenga." },
  { text: "Definir fluxo de atendimento do lead",
    oque: "Definir quem responde o lead no WhatsApp e em quanto tempo (meta: <15 min em horário comercial).",
    porque: "Mídia sem atendimento pronto é balde furado desde o dia 1. O lead esfria em horas." },
  { text: "Configurar o cliente no CRM (plataformas, metas, dia do relatório)",
    oque: "Preencher no cadastro: plataformas (Meta/Google), WhatsApp, dia do relatório e metas acordadas.",
    porque: "É o que conecta o cliente às automações: briefing diário, virada de mês e lembretes." },
];

export const CL_ONB_MIGRACAO = [
  { text: "Auditar a conta herdada ANTES de mexer",
    oque: "Mapear campanhas ativas, aprendizado acumulado, públicos, pixel e histórico de resultados da gestão anterior.",
    porque: "Pausar tudo no dia 1 joga fora aprendizado que o cliente já pagou — o erro clássico do gestor novo." },
  { text: "Diagnosticar a insatisfação real: resultado ou comunicação?",
    oque: "Perguntar ao cliente o que exatamente o incomodava na gestão anterior, com exemplos concretos.",
    porque: "Se era comunicação, seu diferencial é presença e relatório. Se era resultado, é performance. Estratégias opostas." },
  { text: "Documentar a linha de base (últimos 90 dias)",
    oque: "Registrar CPL/CPA/ROAS herdados, com prints e datas, no CRM.",
    porque: "A comparação com a gestão anterior VAI acontecer. Sem linha de base, você não consegue provar evolução." },
  { text: "Preservar o que funciona, corrigir o que vaza",
    oque: "Manter campanhas com custo saudável; atacar primeiro rastreamento, exclusões de público e verba mal alocada.",
    porque: "Quick win vem de estancar vazamento, não de reinventar a conta. Reconstrução total é para casos extremos." },
  { text: "Entregar 1 vitória visível nas 2 primeiras semanas",
    oque: "Escolher uma melhoria de impacto rápido, executar e comunicar ativamente ao cliente.",
    porque: "Cliente queimado decide nos primeiros 30 dias se você é diferente. A primeira impressão é a renovação." },
  { text: "Relatório quinzenal no primeiro mês",
    oque: "Dobrar a frequência de comunicação nos primeiros 30–60 dias (quinzenal em vez de mensal).",
    porque: "Excesso de comunicação no início cura a desconfiança que a gestão anterior criou." },
  { text: "Configurar o cliente no CRM (plataformas, metas, dia do relatório)",
    oque: "Preencher no cadastro: plataformas (Meta/Google), WhatsApp, dia do relatório e metas acordadas.",
    porque: "É o que conecta o cliente às automações: briefing diário, virada de mês e lembretes." },
];

export const ROTEIRO_STATUS_COLORS = {
  "Ativo":     { bg: "var(--success-soft)",    color: "var(--success-ink)" },
  "Estrela":   { bg: "var(--signature-soft)",  color: "var(--signature)" },
  "Arquivado": { bg: "var(--surface-3)",       color: "var(--muted)" },
};

export const ROTEIRO_TIPO_COLORS = {
  "Ads":    { bg: "var(--primary-soft)",      color: "var(--primary)" },
  "Social": { bg: "var(--cat-orange-soft)",   color: "var(--cat-orange-ink)" },
};

export const PLATAFORMAS = ["Reels","Carrossel","Stories","Feed","YouTube","TikTok","LinkedIn","Outro"];

export const TIPOS_ANALISE = [
  "Onboarding","Auditoria IG","Auditoria LP","Auditoria Meta Ads",
  "AC","AT","Plano Mensal","Execução Meta Ads",
  "Calendário","Funil","Estratégia de Aquisição","Continuidade Operacional",
];

export const ANALISE_TIPO_STYLE = {
  "AC":                       { bg: "var(--info-soft)",        color: "var(--info-ink)" },
  "AT":                       { bg: "var(--info-soft)",        color: "var(--info-ink)" },
  "Onboarding":               { bg: "var(--success-soft)",     color: "var(--success-ink)" },
  "Auditoria IG":             { bg: "var(--warn-soft)",        color: "var(--warn-ink)" },
  "Auditoria LP":             { bg: "var(--warn-soft)",        color: "var(--warn-ink)" },
  "Auditoria Meta Ads":       { bg: "var(--warn-soft)",        color: "var(--warn-ink)" },
  "Plano Mensal":             { bg: "var(--cat-violet-soft)",  color: "var(--cat-violet-ink)" },
  "Execução Meta Ads":        { bg: "var(--cat-violet-soft)",  color: "var(--cat-violet-ink)" },
  "Funil":                    { bg: "var(--cat-orange-soft)",  color: "var(--cat-orange-ink)" },
  "Estratégia de Aquisição":  { bg: "var(--cat-orange-soft)",  color: "var(--cat-orange-ink)" },
  "Calendário":               { bg: "var(--cat-purple-soft)",  color: "var(--cat-purple-ink)" },
  "Continuidade Operacional": { bg: "var(--surface-3)",        color: "var(--strong)" },
};
